import ReactDOM from 'react-dom';
import App from 'modules/App';

ReactDOM.render(App(), document.getElementById("main-root"));

if (module.hot)
  module.hot.accept()
